import { useState} from 'react';
import styles from './PageNotFound.module.css';
import SiteBeacon from './SiteBeacon';


function PageNotFound() {

    

    return (
        <div className={styles.pageNotFound}>
            <h1 className={styles.pageNotFoundHeading}>404 — Page not found.</h1>
            <SiteBeacon darkBeacon={true}/>
        </div>

    );
}

export default PageNotFound;
